import styled from "styled-components";

export const Container = styled.div`
  && {
    height: 296mm;
    max-height: 296mm;
    display: flex;
    width: 420mm;
    position: relative;
    zoom: ${({ zoom }) => (zoom ? zoom : "initial")};
    margin: ${({ marginAuto }) => (marginAuto ? "auto" : "0")};
    transform: ${({ mirror }) => (mirror ? "scaleX(-1)" : "initial")};
    @media all {
      .page-break {
        display: none;
      }
    }
    @media print {
      @page {
        size: A3 landscape;
      }
    }

    @media print {
      html,
      body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }

    @media print {
      .page-break {
        margin-top: 1rem;
        display: block;
        page-break-before: auto;
      }
    }

    @page {
      size: auto;
      margin: 20mm;
    }
  }
`;

export const ContainerImg = styled.img`
  && {
    width: 100%;
    height: 100%;
    filter: brightness(${(props) => props.brightness}%)
      saturate(${(props) => props.saturation}%);
  }
`;

export const LogoContainer = styled.div`
  width: 167pt;
  position: absolute;
  right: 30pt;
  top: 20pt;
  max-height: 115pt;
`;
export const LogoAgence = styled.img`
  width: 100%;
`;

export const ContainerDescriptionBottom = styled.div`
  && {
    width: 100%;
    height: 40%;
    display: flex;
  }
`;

export const ExcluContainer = styled.div`
  && {
    padding: 0.5rem;
    width: 204pt;
    background-color: ${(props) => props.colorPrimary};
    position: absolute;
    top: 40pt;
    left: 0pt;
  }
`;

export const Exclu = styled.p`
  && {
    margin-bottom: 0;
    text-align: center;
    font-size: ${(props) => (props.size !== "" ? `${props.size}px` : "26pt")};
    color: ${(props) => (props.color !== "" ? props.color : "black")};
    font-weight: ${(props) => (props.weight !== "" ? props.weight : "bold")};
    font-family: ${(props) =>
      props.family !== ""
        ? props.family
        : "'Open Sans', sans-serif"} !important;
  }
`;
export const QrcodeContainer = styled.div`
  width: 135pt;
  height: 135pt;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 15pt;
  left: 15pt;
`;
export const EnergyContainer = styled.div`
  width: 342.82pt;
  height: 485.88pt;
  max-height: 485.88pt;
  overflow: hidden;
  background-color: ${(props) => props.colorPrimary};
  position: absolute;
  top: 150pt;
  right: 15pt;
  display: flex;
  flex-direction: column;
`;
export const InfoContainer = styled.div`
  width: 540.82pt;
  height: 165.2pt;
  background-color: ${(props) => props.colorPrimary};
  position: absolute;
  top: 655pt;
  right: 15pt;
  display: flex;
`;
export const InfoContainerLeft = styled.div`
  width: 45%;
  padding-left: 20pt;
  padding-top: 8pt;
`;
export const InfoContainerRight = styled.div`
  width: 55%;
  padding-left: 20pt;
  padding-top: 15pt;
`;
export const ContainerPrice = styled.div`
  width: 100%;
`;
export const ContainerAlur = styled.div`
  width: 100%;
  min-height: 100pt;
  padding-top: 1pt;
`;
export const InfoType = styled.p`
  color: ${(props) => props.colorTitle};
  margin-bottom: 0;
  font-size: ${(props) => (props.size !== "" ? `${props.size}pt` : "27pt")};
  font-weight: ${(props) => (props.weight !== "" ? props.weight : "bold")};
  font-family: ${(props) =>
    props.family !== "" ? props.family : "'Open Sans' sans-serif"} !important;
`;
export const InfoCity = styled.p`
  color: ${(props) => props.colorSubTitle};
  margin-top: 0;
  margin-bottom: 0;
  font-size: ${(props) => (props.size !== "" ? `${props.size}pt` : "21pt")};
  font-weight: ${(props) => (props.weight !== "" ? props.weight : "initial")};
  font-family: ${(props) =>
    props.family !== "" ? props.family : "'Open Sans' sans-serif"} !important;
`;
export const Ref = styled.small`
  text-align: left;
  margin-bottom: 0;
  font-size: ${(props) => (props.size !== "" ? `${props.size}px` : "15pt")};
  color: ${(props) => (props.color !== "" ? props.color : "black")};
  font-weight: ${(props) => (props.weight !== "" ? props.weight : "initial")};
  font-family: ${(props) =>
    props.family !== "" ? props.family : "'Open Sans', sans-serif"} !important;
`;
export const AlurText = styled.p`
  font-size: 12px;
  font-weight: initial;
  color: black;
  margin-bottom: 0;
  margin-top: 0;
`;
export const DpeTextContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 35px;
  max-width: 380px;
`;
